import { Phone, MapPin, Clock } from "lucide-react";
import { buildWaLink } from "../data/menu";
import WaIcon from "./WaIcon";

export const Contact = () => {
    return (
        <section
            id="contact"
            className="relative bg-[#FDFBF7] py-16 md:py-24"
            data-testid="contact-section"
        >
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-2 gap-10 items-start">
                <div>
                    <span className="inline-block text-[11px] tracking-[0.32em] font-bold text-[#D35400] bg-[#F5F0E6] rounded-full px-3 py-1.5">
                        RESERVE & ORDER
                    </span>
                    <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-black mt-4 text-[#1F1A17] leading-[1.05]">
                        Hungry? Ping us on WhatsApp.
                    </h2>
                    <p className="mt-5 text-[#7B716A] leading-relaxed max-w-lg">
                        We take orders directly on WhatsApp for the fastest turnaround.
                        Send us your order, we'll confirm the timing and get it to you piping hot.
                    </p>

                    <a
                        href={buildWaLink(
                            "Hi Kiraak Mandi! I'd like to place an order.",
                        )}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn-press mt-7 inline-flex items-center gap-2 bg-[#25D366] hover:bg-[#1EBE53] text-white font-bold px-7 py-4 rounded-full text-base shadow-lg shadow-[#25D366]/25"
                        data-testid="contact-whatsapp-btn"
                    >
                        <WaIcon className="w-5 h-5" />
                        Chat on WhatsApp — +968 7123 1343
                    </a>
                </div>

                <div className="bg-white border border-[#EADEC9] rounded-3xl p-7 md:p-9 shadow-sm space-y-6">
                    <Info
                        icon={Phone}
                        title="Call / WhatsApp"
                        lines={["+968 7123 1343"]}
                        testId="info-phone"
                    />
                    <Info
                        icon={MapPin}
                        title="Visit Us"
                        lines={["Sultanate of Oman", "Find us on Google Maps"]}
                        testId="info-location"
                    />
                    <Info
                        icon={Clock}
                        title="Opening Hours"
                        lines={[
                            "Mon – Thu · 12:00 PM – 11:30 PM",
                            "Fri – Sun · 12:00 PM – 1:00 AM",
                        ]}
                        testId="info-hours"
                    />
                </div>
            </div>
        </section>
    );
};

const Info = ({ icon: Icon, title, lines, testId }) => (
    <div className="flex items-start gap-4" data-testid={testId}>
        <div className="w-11 h-11 rounded-xl bg-[#FFF1E4] text-[#D35400] inline-flex items-center justify-center shrink-0">
            <Icon className="w-5 h-5" />
        </div>
        <div>
            <h3 className="font-display font-bold text-lg text-[#1F1A17]">
                {title}
            </h3>
            {lines.map((l, i) => (
                <p key={i} className="text-sm text-[#7B716A] leading-relaxed">
                    {l}
                </p>
            ))}
        </div>
    </div>
);

export default Contact;
